"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = linear;

function linear(x) {
  return x;
}